import { CheckCircleOutlined, CancelOutlined } from '@mui/icons-material';
import { PopoverOrigin } from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { isNil } from 'ramda';
import { MouseEvent, ReactNode } from 'react';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';
import { useHoverMenu } from '~/components/HoverMenu';

const ANCHOR_ORIGIN: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'center',
};
const TRANSFORM_ORIGIN: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'center',
};

export type StatusCheckCellValue = Union.Nullable<boolean>;

interface StatusCheckCellProps<R extends GridValidRowModel = any> {
  value: StatusCheckCellValue;
  row: R;
  renderList?: () => ReactNode;
}

export const StatusCheckCell = <R extends GridValidRowModel = any>({ value, renderList }: StatusCheckCellProps<R>) => {
  const { menuOpen, menuClose, isDescendant } = useHoverMenu();

  const handleMenuOpen = (event: MouseEvent<HTMLElement>) => {
    menuOpen({
      anchorEl: event.currentTarget,
      anchorOrigin: ANCHOR_ORIGIN,
      transformOrigin: TRANSFORM_ORIGIN,
      children: renderList,
    });
  };
  const mouseLeave = (event: MouseEvent<any>) => {
    if (!isDescendant(event.relatedTarget as any)) {
      menuClose();
    }
  };

  return (
    <>
      {isNil(value) ? (
        NULLISH_CELL_VALUE
      ) : (
        <div
          onMouseEnter={renderList ? handleMenuOpen : undefined}
          onMouseLeave={mouseLeave}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          {value ? <CheckCircleOutlined color="success" /> : <CancelOutlined color="error" />}
        </div>
      )}
    </>
  );
};
